import { Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import { NavLink } from "react-router-dom"

import { cn } from "@/lib/utils"

const tabs = [
  { name: "Assessment", link: "assessment" },
  { name: "Learning", link: "learning" },
].filter((x) => x.link)

const Tabs = () => {
  return (
    <div className="-mb-px flex overflow-auto">
      {tabs.map((item, index) => (
        <NavLink
          replace
          key={index}
          to={item.link}
          className={({ isActive }) =>
            cn(
              "me-3 shrink-0 rounded-none p-0 px-0.25 pb-1 transition-colors",
              {
                "text-body": !isActive,
                "border-b-2 border-primary-500 text-primary-500": isActive,
              },
            )
          }
        >
          {({ isActive }) => (
            <Typography
              variant={isActive ? "strong" : "body"}
              className={clsx({
                "text-onSurface-500": !isActive,
              })}
            >
              {item.name}
            </Typography>
          )}
        </NavLink>
      ))}
    </div>
  )
}

export default Tabs
